import React, { useState, useLayoutEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import ErrorMessages from "helper/errorMessages";
import CompanyLogo from 'assets/studyGramLogo/studygram_logo.png';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, dbFirestore } from "helper/config/firebase";
import RoutingPaths from "helper/routingPath";
import "./index.css"
import { query, collection, where, getDocs } from "firebase/firestore";
import TableName from "helper/tableName/tableName";


const LoginPage = () => {
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

 // use layout method
 useLayoutEffect(() => {
  document.title = "Login"
}, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const inputChange = (e) => {
    const { name, value } = e.target;

    setLoginData({
      ...loginData,
      [name]: value,
    });
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.email) {
      errors.email = ErrorMessages.email;
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = ErrorMessages.emailPattern;
    }
    if (!data.password) {
      errors.password = ErrorMessages.password;
    } else if (!data.password) {
      errors.password = ErrorMessages.passwordLength;
    }

    return errors;
  };

  const tapOnSignIn = () => {
    const newErrors = validateForm(loginData);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      loginApi();
    }
  };

    // MARK: fetch users API
    async function findCurrentUser(user) {
  
      let q = query(collection(dbFirestore, TableName.users), where("user_id", "==", user.uid));
  
      const querySnapshot = await getDocs(q);
      const userArray = querySnapshot.docs.map((docs) => ({ ...docs.data(), }));

      setLoading(false);
      
      if (userArray.length > 0) {
        const role = userArray[0].role
        const userLogin = { ...user, 'role':role }

         localStorage.setItem('session', JSON.stringify(userLogin));

         const loginToken = JSON.stringify(user["accessToken"]);
         localStorage.setItem('token', loginToken);

         navigate(RoutingPaths.home);
        
      } else {
        toast.error('Please insert user informations in user table.');
      }
    }

  // MARK: login API
  const loginApi = () => {
        
    signInWithEmailAndPassword(auth, loginData.email, loginData.password)
        .then((userCredential) => {      
            const user = userCredential.user;
            findCurrentUser(user);
        })
        .catch((error) => {

            setLoading(false);
            const errorCode = error.code;
            const errorMessage = error.message;
            if (errorCode === "auth/invalid-credential") {
                toast.error(ErrorMessages.loginError);
             } else {
                toast.error(errorMessage);
             }
        });
}

  return (
    <div className="login__main-div">
      <div className="login__sub-div">
        <div className="col">
          <div className="card login__card">
          <img src={CompanyLogo} alt="logo" className="login__company__logo"/>
            <h5 className="mb-4 text-center">Welcome</h5>
            <div className="p-fluid">
              <div className="field col-12">
                <label htmlFor="email" className="input__valid">Email</label>
                <InputText
                  name="email"
                  value={loginData.email}
                  onChange={inputChange}
                  id="email"
                  type="text"
                  placeholder="e.g. abc@mail.com"
                />
                {isSubmitted && (
                  <small id="email" className="p-error">
                    {errors.email}
                  </small>
                )}
              </div>
              <div className="field col-12 mt-2">
                <label htmlFor="password" className="input__valid">Password</label>
                <Password
                  name="password"
                  value={loginData.password}
                  onChange={inputChange}
                  id="confirmPassword"
                  placeholder="Enter your password"
                  toggleMask
                  feedback={false}
                  tabIndex={1}
                ></Password>
                {isSubmitted && (
                  <small id="password" className="p-error">
                    {errors.password}
                  </small>
                )}
              </div>
              <Button
                label="Login"
                type="button"
                className="mb-3 mt-4 login__button"
                loading={loading}
                onClick={tapOnSignIn}
              />
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
